import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {editarCompania, mostrarCompanias} from "../../redux/reducers/companiasReducers";

import {
    Box,
    Button,
    Grid, InputAdornment,
    List,
    ListItem,
    ListItemButton,
    ListItemSecondaryAction,
    ListItemText,
    Switch,
    TextField,
    Theme,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {AppBar, HtmlTooltip, MostrarError} from "../../components";
import Strings from "../../assets/strings";
import {TextFieldPhone} from "../../components/CustomTextField";
import {SelectEnum, SelectFiles, SelectZonaHoraria} from "../../components/selects";
import LoadingProgress from "../../components/LoadingProgress";
import {geoString, translateText} from "../../helpers";
import {ConfCamposType, ICompania, IConfCampos} from "../../redux/types/ICompania";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import _ from "lodash";

import CamposFormularios from "./CamposFormularios";
import {IKeyValue} from "../../redux/types/Icommon";
import {mostrarEnumsSinoEsta} from "../../redux/reducers/enumsReducers";
import {Close, Save} from "@mui/icons-material";
import Secuencias from "./Secuencias";
import SelectMoneda from "../../components/selects/SelectMoneda";

const useStyles = makeStyles((theme:Theme) => ({
    root:{
        padding: theme.spacing(1)
    },
    tabs:{
        marginBottom: theme.spacing(2)
    },
    btnTopCont:{
       // overflow:"auto",
        marginBottom:theme.spacing(1),
        borderBottom: "1px solid #d4d4d4",
        position: "sticky",
        //top: "65px",
        background: "#faf9f8",
        zIndex: 4,

        "&>nav":{
            display:"flex",
         //   minWidth: 912,
            "& button":{
                lineHeight: "14px",
                height: 40,
                fontSize: 11,
                fontWeight:"bold",
                color:"#000000",
                borderRadius:0,
                "&.active":{
                    background:theme.palette.primary.dark,
                    color:theme.palette.common.white
                }
            }
        },
        [theme.breakpoints.down('md')]: {
            marginTop:0,
            //     background: "#e6e6e6",
            padding: 1,
            top: "50px",
        },


        "&+div div[class*='topHeader']":{
            position: "sticky",
            top: "65px",
            zIndex: 3,
            background: "#ededed",
        }
    },

    subtitle1:{
        margin: theme.spacing(2)+" auto"
    },
    avatar:{
        "& img":{
            maxWidth: 150
        },
        [theme.breakpoints.down('md')]: {
            "& img":{
                //   borderRadius: "50%",
            }
        }

    },

}));



function Ajustes() {
    let navigate = useNavigate();
    const { hash = null} = useLocation();
    const dispatch = useAppDispatch();


    const {data:compania, status, error} = useAppSelector(state=>state.companias)



    const parametros:IKeyValue[] = useAppSelector(state=>state.enums.list.parametros||[])
    const classes = useStyles();

    const [activedTab, setTab] = React.useState('empresa');
    const [formatoRecibo, setFormatoRecibo] = React.useState<string[]>([]);
    const [state, setState] = useState<ICompania>({
        id: undefined,
        nombre: "",
        direccion: "",
        telefono: "",
        telefono2: "",
        email:"",
        rnc: "",
        logo: "",
        diasGraciaMora: 0,
        porcientoMora: 0,
        tipoMora: undefined,
        moneda: "",
       // genIdioma: "",
        footerRecibo:"",
        formatoRecibo: "",
        confCampos:{},
        parametros: [],
        zonaHorariaId: undefined,
        senderMailName: "",
        senderMailPassword: "",
        senderMailServer: "",
        senderMailPort: "",
    });

    useEffect(()=>{
        if(!!hash && ["#empresa","#recibo","#otros","#camposFormularios","#secuencias"].includes(hash)){
            setTab(hash.replace("#",""));
        }
    },[hash,setTab])
    useEffect(()=> {
        dispatch(mostrarEnumsSinoEsta());
        dispatch(mostrarCompanias());
    },[dispatch]);
    useEffect(()=>{
        let datos = {..._.omitBy(compania, _.isNil)};

        setFormatoRecibo(compania?.formatoRecibo?.split(",") ?? [])

        setState((prev)=>({...prev,...datos}));
    },[setState,setFormatoRecibo,compania])
    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {value,name} = e.target
        setState({...state,[name]:value});
    };
    const handleReciboCheck  = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, checked} = e.target
        let recibo = new Set(formatoRecibo);

        if(checked)
            recibo.add(name)
        else
            recibo.delete(name)
        setFormatoRecibo(Array.from(recibo))
        setState({...state,formatoRecibo:Array.from(recibo).join(",")});
    };
    const handleParamCheck  = ({key,checked}:{key:number,checked:boolean})  => {
        let parametros = [...(state.parametros??[])]

        if(checked) {
            parametros.push({parametro: key});
        }else {
            parametros = parametros?.filter(param => param.parametro !== key);
        }

         setState({...state,parametros});
    };
    const onImgChange = (baseb4:string)=> {
        setState({...state, logo: baseb4});
    }
    const submit = (e:React.FormEvent<HTMLFormElement>) =>{
        e.preventDefault();
        let datos = {...state};
        if(datos.logo === compania?.logo)
            datos.logo = "";

        dispatch(editarCompania(datos));
    }

    return (
        <>
            <AppBar/>


            <div className={classes.btnTopCont}>
                <nav>
                    <Button onClick={()=>navigate("/ajustes#empresa")} className={activedTab === "empresa"?"active":""}>{Strings.empresa}</Button>
                    <Button onClick={()=>navigate("/ajustes#recibo")} className={activedTab === "recibo"?"active":""}>{Strings.recibo}</Button>
                    <Button onClick={()=>navigate("/ajustes#camposFormularios")} className={activedTab === "camposFormularios"?"active":""}>{Strings.formularios}</Button>
                    <Button onClick={()=>navigate("/ajustes#secuencias")} className={activedTab === "secuencias"?"active":""}>Secuencias</Button>
                    <Button onClick={()=>navigate("/ajustes#otros")} className={activedTab === "otros"?"active":""}>{Strings.otros}</Button>
                </nav>
            </div>


            <div className={"contentInner "+classes.root}>


                {status === "loading" && <LoadingProgress/>}
                <MostrarError errors={error}/>

                <form id="form1" onSubmit={submit} style={activedTab !== "empresa"?{display:"none"}:{}}>
                    <div className={"customCard"}>
                        <Typography color={"primary"} className={"title"}>DATOS DE EMPRESA</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={2}>
                                <div className={classes.avatar}>
                                    <SelectFiles showImg src={state.logo ?state.logo:""} onChange={onImgChange}/>
                                </div>
                            </Grid>
                            <Grid item md={10} >
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextField
                                            name="nombre"
                                            label={Strings.empresa}
                                            value={state.nombre}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3}>
                                        <TextFieldPhone
                                            name="telefono"
                                            label={Strings.telefono}
                                            value={state.telefono}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 20}}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3}>
                                        <TextFieldPhone
                                            name="telefono2"
                                            label={Strings.celular}
                                            value={state.telefono2}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 20}}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3}>
                                        <TextField
                                            name="rnc"
                                            label={geoString("rnc",true)}
                                            placeholder={geoString("rnc")}
                                            value={state.rnc}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 20}}
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={6} sm={4} md={3}>
                                        <TextField
                                            name="email"
                                            label={Strings.email}
                                            value={state.email}
                                            type={"email"}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <TextField
                                            name="direccion"
                                            label={Strings.direccion}
                                            value={state.direccion}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 100}}
                                            fullWidth
                                        />
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={"customCard"}>
                        <Typography color={"primary"} className={"title"}>{Strings.mora}</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={6} sm={4} md={3}>
                                <HtmlTooltip title={Strings.diasMoraMsj} disableHoverListener>
                                    <TextField
                                        name="diasGraciaMora"
                                        label={Strings.diasDeGracia}
                                        type="number"
                                        inputProps={{step:1,inputMode:"numeric"}}
                                        value={state.diasGraciaMora}
                                        autoComplete="off"
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </HtmlTooltip>
                            </Grid>
                            <Grid item xs={6} sm={4} md={3}>
                                <HtmlTooltip title={Strings.porcientoMoraMsj} disableHoverListener>
                                    <TextField
                                        name="porcientoMora"
                                        label={Strings.porcentaje}
                                        type="number"
                                        inputProps={{step:"any",inputMode:"decimal"}}
                                        value={state.porcientoMora}
                                        autoComplete="off"
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                        }}
                                    />
                                </HtmlTooltip>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <SelectEnum group={"tiposMora"}
                                            name={"tipoMora"}
                                            label={Strings.aplicarMoraA}
                                            value={state.tipoMora}
                                            onChange={handleChange}/>
                            </Grid>
                        </Grid>
                    </div>
                    {/*<div className={"customCard"}>*/}
                    {/*    <Typography color={"primary"} className={"title"}>Configuración (SMTP)</Typography>*/}
                    {/*    <Grid container spacing={3}>*/}
                    {/*        <Grid item xs={12} sm={4} md={3}>*/}
                    {/*            <TextField*/}
                    {/*                name="senderMailName"*/}
                    {/*                placeholder="ejemplo@gmail.com"*/}
                    {/*                label={"Correo"}*/}
                    {/*                value={state.senderMailName}*/}
                    {/*                onChange={handleChange}*/}
                    {/*                fullWidth*/}
                    {/*            />*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item xs={12} sm={4} md={3}>*/}
                    {/*            <TextField*/}
                    {/*                type={"password"}*/}
                    {/*                name="senderMailPassword"*/}
                    {/*                label={translateText("contrasena")}*/}
                    {/*                value={state.senderMailPassword}*/}
                    {/*                onChange={handleChange}*/}
                    {/*                fullWidth*/}
                    {/*            />*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item xs={12} sm={4} md={3}>*/}
                    {/*            <TextField*/}
                    {/*                name="senderMailServer"*/}
                    {/*                placeholder={"smtp.gmail.com"}*/}
                    {/*                label={"Servidor"}*/}
                    {/*                value={state.senderMailServer}*/}
                    {/*                onChange={handleChange}*/}
                    {/*                fullWidth*/}
                    {/*            />*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item xs={12} sm={4} md={3}>*/}
                    {/*            <TextField*/}
                    {/*                name="senderMailPort"*/}
                    {/*                placeholder={"465"}*/}
                    {/*                label={"Puerto"}*/}
                    {/*                value={state.senderMailPort}*/}
                    {/*                onChange={handleChange}*/}
                    {/*                fullWidth*/}
                    {/*            />*/}
                    {/*        </Grid>*/}
                    {/*    </Grid>*/}
                    {/*</div>*/}
                    <div className={"customCard"}>
                        <Typography color={"primary"} className={"title"}>{Strings.otros}</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={4} md={3}>
                                <SelectZonaHoraria
                                    name="zonaHorariaId"
                                    label={"Zona Horaria"}
                                    value={state.zonaHorariaId?.toString()??""}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <SelectMoneda
                                    name="moneda"
                                    label={Strings.moneda}
                                    value={state.moneda??""}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </form>

            {/*    /!*<BusinessCard state={state}/>*!/*/}

                {activedTab === "camposFormularios" &&
                    <CamposFormularios values={state.confCampos as ConfCamposType} onChange={(confCampos:IConfCampos)=>setState({...state,confCampos})}/>
                }
                {activedTab === "secuencias" &&
                    <Secuencias values={state.secuencias??[]} onChange={(secuencias)=>setState({...state,secuencias})}/>
                }
                {activedTab === "recibo" &&
                <div className="reciboCont" style={{maxWidth:600}}>
                    <List  className={classes.root}>
                        {
                            [
                                {id:"copia",text:Strings.copia},
                                {id:"capital",text:Strings.capital},
                                {id:"mora",text:Strings.mora},
                                {id:"interes",text:Strings.interes},
                                {id:"seguro",text:Strings.seguro},
                                {id:"descuento",text:Strings.descuento},
                                {id:"otros",text:Strings.otros},
                                {id:"capitalRestante",text:Strings.capitalPendiente},
                                {id:"balancePendiente",text:`${Strings.balancePendiente} (${Strings.capital} + ${Strings.interes})`},
                                {id:"proximoPago",text:`${Strings.fecha} ${Strings.proximo} ${Strings.pago}`},
                                {id:"tipoFormaPago",text:Strings.tipoFormaPago},
                                {id:"agente",text:Strings.nombres+" "+Strings.cobrador},
                                {id:"firma",text:Strings.firma},

                            ].map(s=>
                                <ListItem key={s.id}>
                                    <ListItemText id={s.id} primary={s.text} />
                                    <ListItemSecondaryAction>
                                        <Switch
                                            edge="end"
                                            name={s.id}
                                            onChange={handleReciboCheck}
                                            checked={formatoRecibo.includes(s.id)}
                                            inputProps={{ 'aria-labelledby': s.id }}
                                        />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )
                        }
                        <ListItem>
                            <TextField
                                multiline
                                rows={2}
                                name="footerRecibo"
                                label={Strings.piePagina}
                                value={state.footerRecibo}
                                onChange={handleChange}
                                inputProps={{maxLength: 256}}
                                fullWidth
                            />
                        </ListItem>
                    </List>

                        <br/>
                        <br/>
                </div>
                }
                {activedTab === "otros" &&
                <div className="otrosCont" style={{maxWidth:600}}>
                    <List  className={classes.root} component="nav">
                        {
                            parametros.map((s)=> {

                                let checked = Boolean(state.parametros?.find(param => param?.parametro === s?.key));
                                return(
                                    <ListItemButton key={s.key} onClick={()=>handleParamCheck({key:s.key!,checked:!checked})}>

                                        <ListItemText primary={translateText(s.value)}/>
                                        <ListItemSecondaryAction>
                                            <Switch
                                                edge="end"
                                                onChange={()=>{}}
                                                checked={checked}
                                            />
                                        </ListItemSecondaryAction>
                                    </ListItemButton>
                                )
                            })
                        }

                    </List>
                </div>
                }

                <Box className={"formControl"}>
                    <Button sx={{mr:0.5}} color={"error"} onClick={()=>navigate(-1)} variant={"outlined"} disabled={status==="loading"} startIcon={<Close/>} size={"small"}>{Strings.cancelar}</Button>
                    <Button type={"submit"}  form={"form1"} variant={"outlined"} disabled={status==="loading"}  startIcon={<Save/>} size={"small"}>{Strings.guardar}</Button>
                </Box>
            </div>

        </>
    );
}

export default Ajustes;

